// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Drawer that displays a shipment's audit log — the chronological list of
 * lifecycle, field-edit, and serial-delta events recorded for the shipment.
 */
import { AuditDrawer } from '@/components/audit-drawer';
import { ShipmentAuditList } from '@/shipment/components/shipment-audit-list';

interface Props {
  shipmentKey: string;
  disclosure: {
    isOpen: boolean;
    open: () => void;
    close: () => void;
  };
}

export function ShipmentAuditDrawer(props: Props) {
  return (
    <AuditDrawer
      title="Shipment audit log"
      disclosure={props.disclosure}
      auditLog={<ShipmentAuditList shipmentKey={props.shipmentKey} />}
    />
  );
}
